// extracted by mini-css-extract-plugin
module.exports = {"Teaser__root":"LBFP","Teaser__label":"WTlW","Teaser__title":"sPIn","Teaser__text":"S1tQ","Teaser__subtitle":"x_cc","Teasers__btn":"M9Gz"};